import { MaxWidth } from '@imprint-payments/imprint-ui';

export const applicationStatus = {
  noApplication: 'No application found',
  inReview: 'Application still in review',
  notApproved: 'Application not approved',
  haveOffer: 'Offer received',
  alreadySignedUp: 'Already Signed Up',
  creditFrozen: 'Your credit is frozen',
  asyncApplication: 'Evaluating your application',
};

export const applicationEvaluationSignUpStatus = {
  rejectedAfterCooldownWindow: 'rejectedAfterCooldownWindow',
  rejectedWithinCooldownWindow: 'rejectedWithinCooldownWindow',
};

// TODO: replace with constants in productUUIDConstants.ts
export const productID = {
  horizonHobby: 'PRDT-v1-785c001c-a9b1-4fc2-87d7-2d0b1060e3ed',
};

export const FORM_BUTTON_WIDTH = `min(${MaxWidth.Button}, 100vw - 48px)`;
export const TEXT_WIDTH = `min(${MaxWidth.Content}, 100vw - 48px)`;

export const webServicingDisplayURL = 'account.imprint.co';
export const webServicingURL = 'https://account.imprint.co';

export const findAccountDisplayURL = 'account.imprint.co/find-user-account';
export const findAccountURL = 'https://account.imprint.co/find-user-account';

export const transUnionLoginURL =
  'https://service.transunion.com/dss/login.page';
export const transUnionArticleURL =
  'https://www.transunion.com/blog/credit-advice/what-should-i-do-after-i-freeze-my-credit';
export const supportLink = 'imprint.co/help';

export const PHONE_NUMBER_MAX_LENGTH = 16;
